import { useEffect, useState } from "react";
import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import dayjs from "dayjs";
import { restPath, prefix } from './../App';

const MonthlyPaymentButton = ({ setUserInfo, userInfo, setDone }) => {
  const { id, expiry, email, status, orderId } = userInfo;
  const name = userInfo.middleName
    ? `${userInfo.familyName} ${userInfo.middleName} ${userInfo.firstName}`
    : `${userInfo.familyName} ${userInfo.firstName}`;

  const nameEn = userInfo.middleNameEn
    ? `${userInfo.firstNameEn} ${userInfo.middleNameEn} ${userInfo.familyNameEn}`
    : `${userInfo.firstNameEn} ${userInfo.familyNameEn}`;

  const [quantity, setQuantity] = useState(1);
  const [newExpiry, setNewExpiry] = useState("");
  const unitPrice = 400;
  const total = unitPrice * quantity;

  useEffect(() => {
    const today = dayjs();
    const currentExpiry = dayjs(expiry);
    const updated = currentExpiry.isBefore(today)
      ? today.add(quantity, 'month')
      : currentExpiry.add(quantity, 'month');

    setNewExpiry(updated.format("YYYY/MM/DD"));
  }, [quantity, expiry]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const container = document.getElementById("paypal-button-container-monthly");

      if (!window.paypal || !container) {
        console.error("❌ PayPal SDKまたは描画対象が見つかりません");
        return;
      }

      container.innerHTML = "";

      window.paypal.Buttons({
        style: {
          layout: 'vertical',
          color: 'gold',
          shape: 'rect',
          label: 'paypal'
        },

        createOrder: async () => {
          if (status === 'SAVED' && orderId) {
            console.log("🔁 既存注文を再利用:", orderId);
            return orderId;
          }
          try {
            const response = await fetch(`${restPath}/wp-json/${prefix}monthlyplan/v1/create_order`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id,
                quantity,
                amount: total,
                description: `月会員 × ${quantity}ヶ月分`
              })
            });

            const data = await response.json();
            console.log("🧾 orderID from server:", data.orderID);
            return data.orderID;
          } catch (error) {
            console.error("❌ 注文作成エラー:", error);
          }
        },
        onCancel: (data) => {
          console.log("❌ ユーザーが支払いをキャンセルしました:", data);
          setDone(undefined);   // 状態をキャンセルに更新
        },

        onApprove: async (data, actions) => {
          try {
            const details = await actions.order.capture();
            console.log("✅ 支払い完了:", details);

            const confirmResponse = await fetch(`${restPath}/wp-json/monthlyplan/v1/confirm_order`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                orderId: details.id,
                id,
                name,
                nameEn,
                email,
                createTime: details.create_time,
                paypalStatus: details.status,
                quantity,
                amount: total,
                status: details.status,
                expiry: dayjs(newExpiry).format("YYYY-MM-DD")
              })
            });

            const confirmData = await confirmResponse.json();
            if (details.status === `COMPLETED` || details.status === `APPROVED`) {
              const updatedUserInfo = {
                ...userInfo,
                expiry: dayjs(newExpiry).format("YYYY/MM/DD"),
                paymentDate: dayjs().format("YYYY/MM/DD"),
                membership: "supporting",
                quantity,
                unit: `month`,
                amount: total,
                paymentMethod: "paypal",
                orderId: details.id,
                createTime: details.create_time, // ← trim不要
                paypalStatus: details.status,
              };

              setUserInfo(updatedUserInfo);
              sessionStorage.setItem("jacUserCore", JSON.stringify(updatedUserInfo));
              console.log("📬 購入通知完了:", confirmData);
              setDone(`success`);
            } else {
              setDone(`failed`);
            }
          } catch (error) {
            setDone(`failed`);
            console.error("❌ 購入後処理エラー:", error);
          }
        }
      }).render("#paypal-button-container-monthly");
    }, 100);

    return () => clearTimeout(timeout);
  }, [quantity, id, newExpiry]);

  return (
    <Box sx={{ mt: 2 }}>

      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel id="quantity-label">月会員の期間</InputLabel>
        <Select
          labelId="quantity-label"
          value={quantity}
          label="月会員の期間"
          onChange={(e) => setQuantity(Number(e.target.value))}
        >
          {[...Array(12)].map((_, i) => (
            <MenuItem key={i + 1} value={i + 1}>{i + 1}ヶ月分</MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography variant="body1" sx={{ mt: 2 }}>
        小計：₱{total.toLocaleString()}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        更新後の有効期限：{newExpiry}
      </Typography>

      <Box id="paypal-button-container-monthly" sx={{ mt: 2 }} />
    </Box>
  );
};

export default MonthlyPaymentButton;
